module.exports = __webpack_public_path__ + "img/icon-info.f117de1e.svg";